import { TagColorType } from "components/DesignSystem/Tag/Tag";
import {
  BooksGlobalStatus,
  BooksGlobalStatusKey,
  BooksGlobalStatusManualKey,
} from "types/Models/bookkeepingTracker";

export const BOOKS_GLOBAL_STATUS_COLORS: Record<
  BooksGlobalStatusKey,
  TagColorType
> = {
  CONNECT_BANK: "red",
  IN_QUEUE: "gray",
  PREP_IN_PROGRESS: "yellow",
  INTERNAL_REVIEW: "blue",
  PENDING_INFO: "orange",
  DRAFT_SHARED: "purple",
  DRAFT_SHARED_WITH_OPEN_ITEMS: "orange",
  COMPLETED: "green",
};

// Display order of every Books status
export const BOOKS_GLOBAL_STATUSES: BooksGlobalStatus[] = [
  { key: "CONNECT_BANK", name: "Connect Bank" },
  { key: "IN_QUEUE", name: "In Queue" },
  { key: "PREP_IN_PROGRESS", name: "Preparation In Progress" },
  { key: "INTERNAL_REVIEW", name: "Internal Review" },
  { key: "PENDING_INFO", name: "Pending Info" },
  { key: "DRAFT_SHARED", name: "Draft Shared" },
  { key: "DRAFT_SHARED_WITH_OPEN_ITEMS", name: "Draft Shared with Open Items" },
  { key: "COMPLETED", name: "Completed" },
];

// Only these can be set by hand; the rest (incl. Completed) are driven by the backend
export const BOOKS_GLOBAL_MANUAL_STATUSES: BooksGlobalStatusManualKey[] = [
  "IN_QUEUE",
  "PREP_IN_PROGRESS",
  "INTERNAL_REVIEW",
];

// Manual statuses that also move the workflow into its in-progress state
export const BOOKS_GLOBAL_IN_PROGRESS_STATUSES: BooksGlobalStatusManualKey[] = [
  "PREP_IN_PROGRESS",
  "INTERNAL_REVIEW",
];

export const BOOKS_GLOBAL_STATUS_COMPLETED: BooksGlobalStatusKey = "COMPLETED";

export const getBooksGlobalStatusColor = (key: BooksGlobalStatusKey) =>
  BOOKS_GLOBAL_STATUS_COLORS[key] || "gray";

export const isManualBooksGlobalStatus = (
  key: string
): key is BooksGlobalStatusManualKey =>
  (BOOKS_GLOBAL_MANUAL_STATUSES as string[]).includes(key);
